module.exports = __webpack_public_path__ + "static/media/gallery-addBlue.a2e702b4.svg";